import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { breakpoints, media, style } from 'app/assets/styles'
import { H5, SmallText, Text } from 'app/common/typography'
import type { Kid } from 'shared/types'
import Modal from 'react-modal'
import { DeleteModal } from 'app/common/modals'
import { KidsForm } from 'app/kingdom/profile/forms'
import { colors } from 'shared/assets/styles'
import { CircleAvatar, CirclePlus, Close } from 'app/assets/icons'

const { medium } = breakpoints
const { grey, text } = colors

type Props = {
    toggleDisable: () => void,
    mobileModalStyle: any,
    desktopModalStyle: any,
    kids: Array<Kid>,
    maxKids: number,
    deleteKid: string => void
}

type State = {
    openedAddKidModal: boolean,
    modalKidId: ?string,
    width: number
}

class FamilyComponent extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            openedAddKidModal: false,
            modalKidId: null,
            width: window.innerWidth
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions = () => this.setState({ width: window.innerWidth })

    openAddKidModal = () => {
        const { toggleDisable } = this.props
        toggleDisable()
        this.setState({ openedAddKidModal: true })
    }

    closeAddKidModal = () => {
        const { toggleDisable } = this.props
        toggleDisable()
        this.setState({ openedAddKidModal: false })
    }

    openDeleteKidModal = (modalKidId: string) => this.setState({ modalKidId })

    closeDeleteKidModal = () => this.setState({ modalKidId: null })

    render() {
        const {
            mobileModalStyle,
            desktopModalStyle,
            kids,
            maxKids,
            deleteKid
        } = this.props
        const { openedAddKidModal, modalKidId, width } = this.state
        return (
            <Fragment>
                <FormattedMessage id="kingdom.profile.form.family.title">
                    {(text: string) => <H5>{text}</H5>}
                </FormattedMessage>
                <FormattedMessage id="kingdom.profile.form.family.text">
                    {(text: string) => (
                        <Paragraph>
                            <SmallText>{text}</SmallText>
                        </Paragraph>
                    )}
                </FormattedMessage>
                {kids.map((kid: Kid) => (
                    <Fragment key={kid.id}>
                        <KidContainer>
                            <KidInfos>
                                <CircleAvatar />
                                <KidName>{kid.firstname}</KidName>
                            </KidInfos>
                            <CircleStroke
                                onClick={() => this.openDeleteKidModal(kid.id)}>
                                <Close color={text} size={24} />
                            </CircleStroke>
                        </KidContainer>
                        <Modal
                            isOpen={modalKidId === kid.id}
                            ariaHideApp={false}
                            style={style.classicModalStyle}>
                            <DeleteModal
                                handleClose={this.closeDeleteKidModal}
                                handleDelete={() => deleteKid(kid.id)}
                                messageKey="kingdom.profile.form.family.delete.message"
                            />
                        </Modal>
                    </Fragment>
                ))}
                {kids.length < maxKids && (
                    <AddKidButton onClick={this.openAddKidModal} type="button">
                        <CirclePlus color={grey} stroke={grey} small />
                        <Text color={grey}>
                            <FormattedMessage id="kingdom.profile.form.family.button.add" />
                        </Text>
                    </AddKidButton>
                )}
                <Modal
                    isOpen={openedAddKidModal}
                    ariaHideApp={false}
                    style={
                        width < medium - 1
                            ? mobileModalStyle
                            : desktopModalStyle
                    }>
                    <KidsForm handleClose={this.closeAddKidModal} />
                </Modal>
            </Fragment>
        )
    }
}

const Paragraph = styled.p`
    ${props => (props.center ? 'text-align: center' : '')};
`

const KidContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
`

const KidInfos = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const KidName = styled(Text)`
    margin-left: 15px;
`

const CircleStroke = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 28px;
    border: 1px solid ${text};
    border-radius: 25px;
`

const AddKidButton = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: solid 1px ${grey};
    border-radius: 10px;
    margin-top: 5px;
    background-color: white;
    padding-right: 15px;
    width: 100%;
    ${media.medium`
        width: 250px;
    `}
`

export { FamilyComponent }
